import axios from 'axios';





/**
*** フォーム要素が NodeList かチェックする
**/
export const isNodeList = (el) => {
  return Object.prototype.toString.call(el) === '[object RadioNodeList]';
};





/**
*** オブジェクト型かチェック
*** 未使用
**/
export const isObject = (value) => {
  return value !== null && typeof value === 'object';
};





/**
*** オブジェクトの空チェック
*** @use inGroupProp()
**/
export const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};





/**
***  指定したプロパティを要素から取得する
**/
export const getStyle = (el, styleProp) => {
  let defaultView = ( el.ownerDocument || document ).defaultView;
  styleProp = styleProp.replace(/([A-Z])/g, '-$1').toLowerCase();
  return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
};





/**
*** URL解析して、GET クエリ文字列を返す
*** @return {Array} クエリ文字列
*/
export const getQuery = () => {
  // URLを取得
  const url = new URL(window.location.href);

  // URLSearchParamsオブジェクトを取得
  const params = url.searchParams;

  let vars = {};

  params.forEach( (value, key) => {
    vars[key] = value;
  });

  return vars;
};





/**
*** XHR にて結果を取得する
*** @params object 送信するオブジェクト
*** @params ファイル名
*** @return {Array}
*/
export const asyncGetResult = async(object, file) => {
  return axios({
    method: 'POST',
    url: `../XHR/${file}`,
    headers: {'Content-Type': 'application/json'},
    data: JSON.stringify(object)
  })
  .then(function (res) {
    return res.data;
  })
  .catch(function (error) {
    console.log(error);
  });
};





/**
*** XHR にてスラッグの重複をチェックします
*** @params object 送信するオブジェクト
*** @return {Boolean}
*/
export const checkDuplicateSlugs = async(object) => {
  return axios({
    method: 'POST',
    url: `../XHR/checkDuplicateSlugs.php`,
    headers: {'Content-Type': 'application/json'},
    data: JSON.stringify(object)
  })
  .then(function (res) {
    if (res.data) return false;
    return true;
  })
  .catch(function (error) {
    console.log(error);
  });
};





/**
*** 非同期ファイルアップロード
*** @params {File} ファイル
*** @params {String} 識別用文字列
*** @params {String} ディレクトリ
*** @return {Array}
*/
export const asyncFileUpload = async (obj = {}) => {
  const formData = new FormData();
  formData.append('file', obj.file);
  if (obj.uuid) formData.append('uuid', obj.uuid); // 識別用文字列
  formData.append('path', obj.path);   // サブディレクトリ

  return axios({
    method: 'POST',
    url: '../XHR/uuidfileupload.php',
    headers: {'Content-Type': 'multipart/form-data'},
    data: formData
  })
  .then(function (res) {
    //console.log(res.data)
    return res.data;
  })
  .catch(function (error) {
    console.log(error);
  });
};





/**
*** ファイルをアップロードしてマークダウンを記述します
*** @params {File} ファイル
*** @params {String} 識別用文字列
*** @params {String} サブディレクトリ
*** @return {Array}
*/
export const setFileUpload = async (file, uuid, sub) => {
  // 結果を受け取る
  const result = await asyncFileUpload(file, uuid, sub);
  // カーソルの位置
  //result.selection = articleArea.selectionStart;
console.log(result);
  return result;
};





/**
*** ページ遷移感知して画像ファイルのディレクトリを削除
*** @param  {String} ID
*** @param  {String} 識別用文字列
*** @param  {String} ディレクトリ
*** @return {Array}
*/
export const unloadAction = (id, uuid, path) => {
  if (id || !uuid) return;
  axios({
    method: 'POST',
    url: '../XHR/unsetDirectory.php',
    headers: {'Content-Type': 'application/json'},
    data: {
      uuid: uuid,
      path: path
    }
  })
  .then(function (res) {
    return;
  })
  .catch(function (error) {
    console.log(error);
  });
};





/**
*** checkbox-switch の値を取得して任意のファイルに送信します
*** @params {String} ファイルパス
*** @params {Object} パラメータ
*** @return {Array}
*/
export const checkboxSwitchAction = (file, params = {}) => {
  const checkSwitch = document.querySelectorAll('.switch');
  if (!checkSwitch) return;

  for ( const check of checkSwitch ) {
    check.onchange = (e) => {
      const target = e.target;
      // 送信するパラメータ
      const send = {
        status:     target.checked ? 1 : 2,
        id:         target.getAttribute('id')
      };
      // パラメータを送信
      axios({
        method: 'POST',
        url: file,
        headers: {'Content-Type': 'application/json'},
        data: JSON.stringify({...send, ...params})
      })
      .then(function (res) {
        return;
        console.log(res.data);
      })
      .catch(function (error) {
        console.log(error);
      });
    }
  }
};








// ---------- ---------- ---------- ---------- ---------- ---------- ----------





/**
*** フォーム要素の type を取得する
**/
export const getType = (target) => {
  return isNodeList(target) ? target[0].type : target.type;
};





/**
*** フォーム要素の name を取得する
**/
export const getName = (target) => {
  return isNodeList(target) ? target[0].name : target.name;
};





/**
*** フォーム要素のファイルサイズを取得する
**/
export const getFilesSize = (target) => {
  let fileSizeArray = [];
  if( target.type === 'file' && target.value ){
    for( const file of target.files ){
      fileSizeArray.push(file.size);
    }
    return fileSizeArray.join(',');
  }
  return false;
};





/**
*** フォーム要素のファイルタイプを取得する
**/
export const getFilesType = (target) => {
  let fileTypeArray = [];
  if( target.type === 'file' && target.value ){
    for( const file of target.files ){
      fileTypeArray.push(file.type);
    }
    return fileTypeArray.join(',');
  }
  return false;
};





/**
*** ラジオボタンとチェックボックスの textContent を取得する
**/
export const getTextContent = (target) => {
  let textArray = [];
  if( isNodeList(target) ){
    for( const item of target ){
      // ラジオボタンとチェックボックスだけを処理します
      if( item.type !== 'radio' && item.type !== 'checkbox' ) continue;

      const text = document.querySelector(`[for="${item.getAttribute('id')}"]`).textContent;

      // ラジオボタン
      if( item.type === 'radio' ){
        if( item.checked ){
          return text;
        }
      }
      // チェックボックス
      if( item.type === 'checkbox' ){
        if( item.checked ){
          textArray.push(text);
        }
      }
    }
    return textArray.join(','); // チェックボックス
  } else {
    // ラジオボタン
    if( target.type === 'radio' || target.type === 'checkbox' ){
      return target.checked ? document.querySelector(`[for="${target.getAttribute('id')}"]`).textContent : null;
    }
    // セレクトボックス
    else if( target.type === 'select-one' ){
      const index = target.selectedIndex;
      // disabled 属性が false のものだけ取得
      if( target[index].disabled === false ){
        return target[index].textContent;
      }
    }
  }
  return false;
};





/**
*** group に含まれているかチェック
*** @param {*} フォーム要素の名前
*** @use getNormalorGroupName()
**/
export const inGroupProp = (name) => {
  const obj = Parameters.group;
  let property = false;
  if( ! isObjectEmpty(obj) ){
    for( const prop in obj ){
      // group に含まれているか
      const reg = new RegExp('\\b' + name + '\\b');
      if( obj[prop].match(reg) !== null ){
        property = prop;
      };
    }
  }
  return property;
};





/**
*** 通常の name  OR group の name を取得する
*** @param {*} フォーム要素の名前
*** @use getErrorElement()
**/
export const getNormalorGroupName = (name) => {
  // group に含まれているかチェック 含まれていれば group の name が返ってくる
  const isGroup = inGroupProp(name);
  return isGroup ? isGroup : name;
};





// ---------- ---------- ---------- ---------- ---------- ---------- ---------- Error

/**
*** エラーメッセージを表示する要素を取得する
**/
export const getErrorElement = (name) => {
  // 通常の name  OR group の name を取得する
  const elmName = getNormalorGroupName(name);
  return document.getElementById( elmName.replace( /\[\]/g, '' ) + '_error' );
};





/**
*** エラーメッセージの出力
**/
export const errorMessage = (str) => {
  return `<span class="error">${str}</span>`;
};





// フォーム要素のタイプの配列
const typeArray = [
  [ 'text', 'number', 'password', 'tel', 'url', 'textarea' ],
  [ 'select-one', 'radio', 'checkbox' ]
];

// 付与するクラス名
const validClass = 'valid',
      errorClass = 'error';




/**
*** エラーメッセージの表示処理
**/
export const execError = ( target, element, message ) => {

  if( ! element ) return;

  element.innerHTML = errorMessage(message);
  element.classList.add(validClass);

  // input 要素のものはエラー用の .error クラスを付ける
  if( typeArray[0].includes( getType(target) ) || getType(target) === 'select-one' ){
    target.classList.add(errorClass);
  };

};





/**
*** エラーメッセージの消去処理
**/
export const eraseError = ( target, element ) => {

  if( ! element ) return;

  element.innerHTML = '';
  element.classList.remove(validClass);

  // input 要素のものはエラー用の .error クラスを消去する
  if( typeArray[0].includes( getType(target) ) || getType(target) === 'select-one' ){
    target.classList.remove(errorClass);
  };

};
